import StudyListTable from './StudyListTable.tsx';
import StudyListTableRow from './StudyListTableRow.tsx';

export default StudyListTable;

export { StudyListTable, StudyListTableRow };
